import firebase from 'firebase'

export default {
  state:{
    users: [],
    user: {},
  },
  getters: {
    users: state => state.users,
    user: state => state.user
  },
  mutations: {
    setUsers(state,payload) {
      state.users = payload
    },
    setUser(state,payload) {
      state.user = payload
    }
  },
  actions: {
    getUsers: function(context){
      firebase.firestore().collection('users')
        .get({ source: 'server' })
        .then(docs => {
          let usersArray = []
          docs.forEach( doc => {
            const user = doc.data()
            const deletedAt = user.deletedAt
            if (deletedAt === undefined || deletedAt === null) {
              usersArray.push({ uid: doc.id, ...user })
            }
          });
          context.commit('setUsers',usersArray)
        })
    },
    subscribeToUsers: function(context){
      const usersRef = firebase.firestore().collection('users')
      usersRef.onSnapshot( docs => {
        let usersArray = []
        docs.forEach( doc => {
          let user = doc.data()
          const deletedAt = user.deletedAt
          if ( user.uid && (deletedAt === undefined || deletedAt === null) ){
            usersArray.push(user)
          }
        })
        context.commit('setUsers',usersArray)
      })
    },
    getUser: function(context, uid){
      const usersRef = firebase.firestore().collection('users').doc(uid).get()
        .then(doc => {
            let user = doc.data()
            context.commit("setUser", user)
          });
    },
    doesUserExist: async function(context, uid){
      console.log("doesUserExist: ", uid)
      const usersRef = firebase.firestore().collection('users').doc(uid)
      return await usersRef.get()
        .then(doc => {
          if ( doc.exists ) {
            return true
          } else {
            return false
          }
        });
    },
    getUserOrg: async function(context, uid){
      const orgRef = firebase.firestore().collection('organizations').where("members", "array-contains", uid)
      return await orgRef.get()
      .then( docs => {
        let orgArray = []
        docs.forEach( doc => {
          let org = doc.data()
          orgArray.push(org)
        })
        let org = orgArray[0]
        let orgObj = {
          name: org.name,
          key: org.key,
          orgId: org.orgId
        }
        return orgObj
      })
    },
  }
}
